export const applyContext = {
  channel: "APPLY",
  type: "general",
  mappings: [
    {
      key: "apply",
      useDefault: true,
      isGeneric: true,
      useReportingData: true,
      url: "/business/deposit/",
      categoryId: "APPLY_BB_PSP_USBANK",
      page_key: "DEFAULT",
      reportData: {
        fields: [
          {
            key: "F99_isCustomerContactReceived",
            type: "boolean",
            conditional: {
              comparison: "EQUALS",
              value: true,
              passActions: [
                { task: "pageKey", type: "value", valueKey: "F99_DECLINE" },
                { task: "categoryId", type: "value", valueKey: "APPLY_BB_PSP_USBANK" },
                { task: "exit" },
              ],
              failActions: [
                {
                  task: "next",
                },
              ],
            },
          },
          {
            key: "F95_isSoftDecline",
            type: "boolean",
            conditional: {
              comparison: "EQUALS",
              value: true,
              passActions: [
                { task: "pageKey", type: "value", valueKey: "F95_DECLINE" },
                { task: "categoryId", type: "value", valueKey: "APPLY_BB_PSP_USBANK" },
                { task: "exit" },
              ],
              failActions: [
                {
                  task: "next",
                },
              ],
            },
          },
          {
            key: "currentPage",
            type: "string",
            conditional: {
              comparison: "NOT_EQUALS",
              value: null,
              passActions: [
                { task: "pageKey", type: "variable", valueKey: "currentPage" },
                { task: "categoryId", type: "value", valueKey: "APPLY_BB_PSP_USBANK" },
                { task: "exit" },
              ],
              failActions: [{ task: "pageKey", type: "value", valueKey: null }],
            },
          },
        ],
      },
    },
  ],
};
